<template>
  <div ref="layout" v-loading="loading" class="page-form">
    <affix>
      <div class="tools">
        <form-button name="提交" icon="form-advance" />
        <form-button name="取消" type="primary" @click="$emit('close')" />
      </div>
    </affix>

    <h3 class="title">货权转移发货申请表</h3>
    <!-- <btky-header
      :form-data="wlyApplyForGoodsPo"
      :process-key="processKey"
      @formDataSave="saveData"
      @validate="validate"
      @advanceSuccess="advanceSuccess"
    /> -->

    <div class="form-container">
      <el-form inline size="small" label-width="110px" :model="wlyApplyForGoodsPo" :rules="rules">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="发货单号" label-width="">
              <el-input
                v-model="wlyApplyForGoodsPo.wantCode"
                placeholder="自动生成"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="订单客户" label-width="" prop="customerName">
              <el-input
                v-if="isClient==='1'"
                v-model="wlyApplyForGoodsPo.customerName"
                placeholder="请输入"
                type="text"
                clearable
                disabled
              />
              <el-input v-if="isClient==='0'" v-model="wlyApplyForGoodsPo.customerName" disabled placeholder="请输入" @focus="showClientDialog" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="开票客户" label-width="">
              <el-input
                v-model="wlyApplyForGoodsPo.billCustomer"
                placeholder="请输入"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="计划类型" prop="zZFLD00002Q">
              <el-select v-model="wlyApplyForGoodsPo.zZFLD00002Q" disabled>
                <el-option v-for="item in selectDataOptions['A0002']" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="制单票据类型" label-width="" prop="noticeSheetType">
              <el-select v-model="wlyApplyForGoodsPo.noticeSheetType" disabled>
                <el-option v-for="item in selectDataOptions['A0022']" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 取经销商该年度签署合同渠道、如果不是配额计划，渠道为空 -->
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="渠道类型" label-width="">
              <el-select v-model="wlyApplyForGoodsPo.channelsType">
                <el-option v-for="item in selectDataOptions['A0054']" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="配额年度" label-width="" prop="quotasYear">
              <el-date-picker
                v-model="wlyApplyForGoodsPo.quotasYear"
                :clearable="false"
                format="yyyy"
                value-format="yyyy"
                type="year"
                placeholder="配额年度"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="营销中心" label-width="">
              <el-select
                v-model="wlyApplyForGoodsPo.ZZFLD000001"
                placeholder="请选择"
                type="select"
                clearable
                disabled
                @change="saleCenterChange"
              >
                <el-option
                  v-for="item in selectDataOptions['orgList']"
                  :key="item.zzfld00001h"
                  :label="item.mc_short"
                  :value="item.zzfld00001h"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="紧急程度" label-width="">
              <el-select v-model="wlyApplyForGoodsPo.saleCenter">
                <el-option v-for="item in selectUrgentOptions" :key="item.key" :label="item.value" :value="item.key" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row class="btky-tr">
          <el-button type="primary" size="medium" @click="queryGoodsDetail">查询制票单明细</el-button>
        </el-row> -->

        <common-title title="收货信息" />
        <el-row :gutter="24">
          <!-- 是 分流经销商 分流收货单位 必填 -->
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="是否分流：" label-width="">
              <el-select v-model="wlyApplyForGoodsPo.isShunt" @change="isShuntChange">
                <el-option v-for="item in selectDataOptions['B0099']" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 开票客户的分流经销商 -->
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="分流经销商" label-width="">
              <el-input
                v-model="wlyApplyForGoodsPo.shuntDealer"
                placeholder="请输入"
                type="text"
                suffix-icon="el-icon-more"
                clearable
                @focus="showClientDialog"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="分流渠道类型" label-width="">
              <el-select v-model="wlyApplyForGoodsPo.shuntChannelsType" />
            </el-form-item>
          </el-col>
          <!-- 开票客户的分流经销商 -->
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="分流收货单位" label-width="">
              <el-input
                v-model="wlyApplyForGoodsPo.shuntReceiveUnitName"
                suffix-icon="el-icon-more"
                clearable
                @focus="showClientDialog"
              />
            </el-form-item>
          </el-col>
          <!-- 客户的收货地址 -->
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="收货单位" label-width="" prop="receiveUnitName">
              <el-input
                v-model="wlyApplyForGoodsPo.receiveUnitName"
                placeholder="请输入"
                type="text"
                clearable
                suffix-icon="el-icon-more"
                @focus="showClientDialog"
              />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="收货联系人" label-width="">
              <el-input
                v-model="wlyApplyForGoodsPo.contacPerson"
                placeholder="请输入"
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="联系电话" label-width="">
              <el-input
                v-model="wlyApplyForGoodsPo.contactNumber"
                placeholder="请输入"
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="16" :md="12">
            <el-form-item class="widget-view" label="收货地址" label-width="" prop="receiveAddress">
              <el-input
                v-model="wlyApplyForGoodsPo.receiveAddress"
                placeholder="请输入"
                type="text"
                clearable
              />
              <!-- <el-select v-model="wlyApplyForGoodsPo.receiveAddress" placeholder="请选择" type="select" @change="addressChange">
                <el-option v-for="item in selectReceiveAddressOptions" :key="item.id" :label="item.address" :value="item.id" />
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="widget-view" label="备注" label-width="">
              <el-input
                v-model="wlyApplyForGoodsPo.remark"
                placeholder="请输入"
                resize="none"
                :autosize="{minRows: 2, maxRows: 2}"
                type="textarea"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 渠道类型选择KA时 -->
        <common-title v-if="wlyApplyForGoodsPo.channelsType == 'K'" title="KA卖场信息" />
        <el-row v-if="wlyApplyForGoodsPo.channelsType == 'K'" :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="卖场全称" label-width="">
              <el-input
                v-model="wlyApplyForGoodsPo.bigStoreName"
                placeholder="请输入"
                type="text"
                clearable
                suffix-icon="el-icon-more"
                @focus="showClientDialog"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="卖场简称" label-width="">
              <el-input
                v-model="wlyApplyForGoodsPo.bigStoreName"
                placeholder="请输入"
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <!-- 订单客户所在区域 -->
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="卖场区域" label-width="">
              <el-select v-model="wlyApplyForGoodsPo.bigStoreArea" />
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>

    <div class="table-container">
      <TableCommon
        title="要货明细"
        :custome-config="() => vxeShowCustom('xTable')"
      >
        <template #button>
          <table-button name="add" tip="增加" @click="insertData" />
          <table-button name="delete" tip="删除" @click="removeData" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="300"
          align="center"
          size="medium"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.gridOptions.columns"
          :data="gridOptions.gridOptions.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridOptions.gridOptions.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <el-input
                v-if="gridOptions.columnsFieldTypes[item.field] == 'input'"
                v-model="row[item.field]"
              />
              <span v-else>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon
        v-if="isApplyForGoodsDetailShow"
        title="开票信息"
        :custome-config="() => vxeShowCustom('xTable2')"
      >
        <vxe-grid
          ref="xTable2"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="240"
          align="center"
          size="medium"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions3.gridOptions.columns"
          :data="gridOptions3.gridOptions.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridOptions3.gridOptions.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <el-input
                v-if="gridOptions3.columnsFieldTypes[item.field] == 'input'"
                v-model="row[item.field]"
              />
              <span v-else>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon
        title="附件"
        :custome-config="() => vxeShowCustom('xTable3')"
      >
        <template #button>
          <el-upload
            ref="upload"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="xTable3"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="medium"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions2.gridOptions.columns"
          :data="gridOptions2.gridOptions.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridOptions2.gridOptions.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <el-input
                v-if="gridOptions2.columnsFieldTypes[item.field] == 'input'"
                v-model="row[item.field]"
                size="medium"
              />
              <span v-else>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <el-dialog v-dialogDrag title="客户选择" :visible.sync="clientDialog" width="70%" :append-to-body="true">
      <client-select v-if="clientDialog" ref="ClientSelect" />
      <div slot="footer">
        <el-button type="default" icon="el-icon-circle-close" size="small" @click="clientDialog = false">取消</el-button>
        <el-button type="primary" icon="el-icon-circle-check" size="small" @click="confirmSelect">确定</el-button>
      </div>
    </el-dialog>

    <!-- <btky-footer :form-data="wlyApplyForGoodsPo" /> -->
  </div>
</template>
<script>

import { webUploadFile, apiFindAllClientInfo, apiSapClientFindInfo } from '@/api/common'
import { findAddressByClientId } from '@/api/client'
import { findWantGoodsDetailByClient, wantgoodsFindById, findWantGoodsDetailById } from '@/api/applyForGoods/index'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { handlerFlow } from '@/api/flowHander'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import { mapGetters } from 'vuex'

const TColumns = [
  {
    field: 'grouponPlanAmount',
    title: '团购当月计划量',
    width: 120
  },
  {
    field: 'grouponApplyAmount',
    title: '团购当月申请量',
    width: 120
  },
  {
    field: 'grouponSurplusAmount',
    title: '团购当月剩余量',
    width: 120
  }
]

export default {
  name: 'CargoTransferApplyEdit',
  components: {
    ClientSelect
  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    mid: {
      type: String,
      default: ''
    }
  },
  data() {
    const rules = {
      customerName: [{ required: true, message: '请选择订单客户', trigger: 'change' }],
      noticeSheetType: [{ required: true, message: '请选择制票单据类型', trigger: 'change' }],
      receiveUnitName: [{ required: true, message: '请选择收货单位名称', trigger: 'blur' }],
      quotasYear: [{ required: true, message: '请选择配额年度', trigger: 'change' }]
    }
    return {
      processKey: 'wantGoods',
      rules,
      isClient: '0',
      clientDialog: false,
      wlyApplyForGoodsPo: {
        id: '',
        taskId: '',
        bizId: '',
        status: 0,
        billCode: '',
        billStatus: 'E001',
        billCustomer: '',
        shuntDealer: '',
        clientId: '',
        brandBq: '',
        ticketDetailId: '',
        remark: '',
        customerCode: '',
        customerName: '',
        zZFLD00002Q: '',
        noticeSheetType: '',
        channelsType: '',
        quotasYear: '',
        ZZFLD000001: '', // 营销单元
        isShunt: '0',
        bigStoreName: '',
        bigStoreArea: '',
        receiveUnitName: '',
        receiveAddress: '',
        contacPerson: '',
        contactNumber: '',
        shuntChannelsType: '',
        shuntReceiveUnitCode: '',
        shuntReceiveUnitName: '',
        spurtCodeUnit: ''
      },
      selectDataOptions: {},
      selectChannelOptions: {},
      selectSaleCenterOptions: {},
      selectReceiveAddressOptions: {},
      selectUrgentOptions: [
        {
          key: '1',
          value: '正常'
        }
      ],
      receiveAddressTemp: {},
      loading: false,
      pagination: {
        totalCount: 0,
        page: 1,
        pagesize: 50
      },
      gridOptions: {
        gridOptions: {
          columns: [
            { type: 'checkbox', title: '序号', filed: 'seq', width: 90 },
            {
              field: 'brandBqTextView',
              title: '品牌',
              width: 120
            },
            {
              field: 'productDesc',
              title: '产品名称',
              width: 120
            },
            {
              field: 'planAmount',
              title: '传统当月计划量',
              width: 120
            },
            {
              field: 'applyAmount',
              title: '传统当月申请量',
              width: 120
            },
            {
              field: 'surplusAmount',
              title: '传统当月剩余量',
              width: 120
            },
            {
              field: 'surplusAmountYear',
              title: '传统当年剩余量',
              width: 120
            },
            {
              field: 'undeliveredQuantity',
              title: '未发货量',
              width: 120
            },
            {
              field: 'wantQuantity',
              title: '本次要货量',
              width: 120,
              slots: { default: 'wantQuantity' }
            },
            {
              field: 'remark',
              title: '备注',
              width: 120,
              slots: { default: 'remark' }
            }
          ],
          data: []
        },
        columnsFieldTypes: { remark: 'input', wantQuantity: 'input' }
      },
      gridOptions3: {
        gridOptions: {
          columns: [
            { type: 'seq', title: '序号', filed: 'seq', width: 90 },
            {
              field: 'brandBqTextView',
              title: '开票客户',
              width: 120
            },
            {
              field: 'productDesc',
              title: '发票号',
              width: 120
            },
            {
              field: 'planAmount',
              title: '开票时间',
              width: 120
            },
            {
              field: 'applyAmount',
              title: '产品名称',
              width: 120
            },
            {
              field: 'surplusAmount',
              title: '开票总量（件）',
              width: 120
            },
            {
              field: 'surplusAmountYear',
              title: '本次占用（件）',
              width: 120
            },
            {
              field: 'undeliveredQuantity',
              title: '剩余量',
              width: 120
            }
          ],
          data: []
        },
        columnsFieldTypes: {}
      },
      gridOptions2: {
        gridOptions: {
          columns: [
            { type: 'checkbox', title: '', filed: 'checkbox', width: 50 },
            {
              field: 'fileName',
              title: '附件名称',
              slots: { default: 'fileName' },
              editRender: { name: 'input' }
            },
            {
              field: 'fileType',
              title: '附件类型',
              slots: { default: 'fileType' },
              editRender: { name: 'input' }
            },
            {
              field: 'fileSize',
              title: '大小',
              slots: { default: 'fileSize' },
              editRender: { name: 'input' }
            },
            {
              field: 'createdDate',
              title: '上传时间',
              slots: { default: 'createdDate' },
              editRender: { name: 'input' }
            }
          ],
          data: [],
          editConfig: { trigger: 'click', mode: 'cell' }
        }
      }
    }
  },
  computed: {
    // 审批、单据查询 出现
    isApplyForGoodsDetailShow() {
      return false
    },
    ...mapGetters(['userInfo'])
  },
  watch: {
    'gridOptions.gridOptions.data': {
      handler(val) {
        this.wlyApplyForGoodsPo.wantGoodsDetailList = val
        this.wlyApplyForGoodsPo.wantGoodsDetailList.forEach(v => {
          v.planQuantity = this.gridOptions.gridOptions.columns.length === 9 ? v.planAmount : v.grouponPlanAmount
        })
      },
      deep: true
    },
    'gridOptions2.gridOptions.data': {
      handler(val) {
        this.wlyApplyForGoodsPo.attachmentList = val
      },
      deep: true
    },
    'wlyApplyForGoodsPo.isShunt': {
      handler(val) {
        if (val === '0') {
          this.wlyApplyForGoodsPo.shuntReceiveUnitName = ''
          this.wlyApplyForGoodsPo.shuntReceiveUnitCode = ''
          this.wlyApplyForGoodsPo.shuntChannelsType = ''
          this.wlyApplyForGoodsPo.shuntDealer = ''
        }
      }
    },
    'wlyApplyForGoodsPo.channelsType': {
      handler(val, old) {
        if (val === 'T') {
          this.gridOptions.gridOptions.columns.push(...TColumns)
        }
        if (old === 'T') {
          this.gridOptions.gridOptions.columns.splice(-3)
        }
      }
    }
  },
  created() {
    this.init()
    if (this.mode === 'add') {
      // this.getUserInfo()
    } else {
      // 变更编辑单
      if (this.mode === 'edit') {
        for (const key in this.wlyApplyForGoodsPo) {
          if (Object.hasOwnProperty.call(this.wlyApplyForGoodsPo, key)) {
            this.wlyApplyForGoodsPo[key] = this.rowData[key]
          }
        }
      }
      this.wlyApplyForGoodsPo.quotasYear = new Date(`${this.rowData.annual}`)
      this.wlyApplyForGoodsPo.customerName = this.rowData.custName
      this.wlyApplyForGoodsPo.id = this.mid
      this.wlyApplyForGoodsPo.bizId = this.mid
      this.handleQueryById()
    }
  },

  methods: {
    init() {
      // 计划类型
      this.getSelectDictDataOrigin('A0002')
      // 通知单类型
      this.getSelectDictDataOrigin('A0022')
      // 是否分流
      this.getSelectDictDataOrigin('B0099')
      // 渠道类型
      this.getSelectDictDataOrigin('A0054')
    },
    async handleQueryById() {
      this.loading = true
      const params = {
        id: this.$route.query.id
      }
      try {
        const res = await wantgoodsFindById(params)
        this.loading = false
        Object.assign(this.wlyApplyForGoodsPo, res.data)
        this.initCustome()
        this.wlyApplyForGoodsPo.quotasYear += ''
        const detailData = await findWantGoodsDetailById({ id: res.data.id })
        this.gridOptions.gridOptions.data = detailData.data
      } catch (error) {
        //
      }
      this.loading = false
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    async getSelectLists(clientInfo) {
      this.selectChannelOptions = clientInfo.clientChannels
      this.selectSaleCenterOptions = clientInfo.clientOrgList

      const params2 = { 'clientId': this.wlyApplyForGoodsPo.clientId, 'addressType': '2' }
      await findAddressByClientId(params2).then(res => {
        this.receiveAddressTemp = res.data.Rows
        this.selectReceiveAddressOptions = res.data.Rows
      })
    },
    // 查询客户信息
    async initCustome() {
      const params = {
        rt_partner: [
          {
            SIGN: 'I',
            OPTION: 'EQ',
            LOW: this.conditions.CUSTOMER,
            HIGH: ''
          }
        ],
        page: 1,
        pagesize: 50
      }
      // 当前登录账号和角色
      params.partner = this.$store.getters.role.USER_BP
      params.role = this.$store.getters.role.ROLE
      const { data } = await apiSapClientFindInfo(params)
      this.$set(this.selectDataOptions, 'orgList', data[0].yxdy)
    },
    // 查询客户信息
    async initCustome2() {
      const {
        data: { Rows }
      } = await apiFindAllClientInfo({
        customerCode: this.wlyApplyForGoodsPo.customerCode,
        page: 1,
        pagesize: 50
      })
      this.getSelectLists(Rows[0])
    },
    // 选择营销单元
    saleCenterChange(e) {
      const checkedData = this.selectDataOptions.orgList.find(v => v.zzfld00001h === e)
      this.wlyApplyForGoodsPo.ZZFLD000001Name = checkedData.mc_short
      this.wlyApplyForGoodsPo.ZZFLD00003E = checkedData.zzfld00003e
      this.wlyApplyForGoodsPo.ZZFLD00003EName = checkedData.mc_short_jd
    },
    // 选择客户
    async confirmSelect() {
      const data = await this.$refs.ClientSelect.submitForm()
      this.wlyApplyForGoodsPo.clientId = data.id
      this.wlyApplyForGoodsPo.customerName = data.customerName
      this.wlyApplyForGoodsPo.customerCode = data.customerCode
      this.wlyApplyForGoodsPo.receiveUnitName = data.customerName
      this.wlyApplyForGoodsPo.billCustomer = data.billCustomer
      this.getSelectLists(data)
      this.clientDialog = false
    },
    isShuntChange() {},
    async queryGoodsDetail() {
      this.loading = true

      const { customerCode, zZFLD00002Q, noticeSheetType, quotasYear } = this.wlyApplyForGoodsPo
      const params = {
        ...this.pagination,
        customerCode,
        noticeSheetType,
        zZFLD00002Q,
        quotasYear
      }

      if (customerCode && noticeSheetType && quotasYear) {
        findWantGoodsDetailByClient(params).then(res => {
          res.data.forEach(item => {
            item.wantQuantity = ''
            item.undeliveredQuantity = item.isShipment
          })
          this.gridOptions.gridOptions.data = []
          this.gridOptions.gridOptions.data.unshift(...res.data)
        })
      } else {
        this.$refs['form'].validateField(['customerName', 'noticeSheetType', 'quotasYear'])
      }

      this.loading = false
    },
    addressChange() {
      this.receiveAddressTemp.forEach(item => {
        if (this.wlyApplyForGoodsPo.receiveAddress === item.id) {
          this.wlyApplyForGoodsPo.contacPerson = item.linkman
          this.wlyApplyForGoodsPo.contactNumber = item.mobile
        }
      })
    },
    showClientDialog(e) {
      this.clientDialog = true
      e.target.blur()
    },
    insertData() {
      const columns = this.gridOptions.gridOptions.columns.filter(v => !v.type)
      const data = {}
      for (const key in columns) {
        data[columns[key].field] = ''
      }
      this.gridOptions.gridOptions.data.unshift(data)
    },
    async removeData() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()
      // const hasIds = checkedList.filter(v => v.id)

      // if (hasIds.length) {
      //   const ids = hasIds.map(v => v.id).join(',')
      //   await deleteDeliverControl({ ids })
      // }
      checkedList.forEach(item => {
        const index = this.gridOptions.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.gridOptions.data.splice(index, 1)
      })
    },
    async uploadFile(file) {
      const formData = new FormData()
      formData.append('bizId', 789456)
      formData.append('bizCode', 55552)
      formData.append('formSecretLevel', 0)
      formData.append('name', file.name)
      formData.append('type', file.raw.type)
      formData.append('lastModifiedDate', file.raw.lastModifiedDate)
      formData.append('size', file.size)
      formData.append('file', file.raw)
      const { data } = await webUploadFile(formData)
      data.file_id = data.id
      delete data.id
      this.gridOptions2.gridOptions.data.unshift(data)
    },
    // 删除合同附件
    delUpload() {
      const checkedList = this.$refs.xTable3.getCheckboxRecords()

      checkedList.forEach(item => {
        const index = this.gridOptions2.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions2.gridOptions.data.splice(index, 1)
      })
    },
    validate(cb) {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          cb()
        }
      })
    },
    saveData() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          // this.wlyApplyForGoodsPo.wantGoodsDetailList = this.gridOptions.gridOptions.data
          // this.wlyApplyForGoodsPo.attachmentList = this.gridOptions2.gridOptions.data
          const params = JSON.parse(JSON.stringify(this.wlyApplyForGoodsPo))
          handlerFlow(params, this.processKey)
            .then(response => {
              this.loading = false
              if (!this.wlyApplyForGoodsPo.id) {
                this.id = response.data.bizId

                this.wlyApplyForGoodsPo.id = response.data.bizId
                this.wlyApplyForGoodsPo.bizId = response.data.bizId
                this.wlyApplyForGoodsPo.taskId = response.data.taskId
                this.wlyApplyForGoodsPo.procInstId = response.data.bizprocInstId
                this.wlyApplyForGoodsPo.billCode = response.data.bizData.billCode
                this.wlyApplyForGoodsPo.billStatus = response.data.bizData.billStatus
                this.wlyApplyForGoodsPo.createdByName = response.data.bizData.createdByName
              }
              this.$message.success('保存成功')
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
    // 提交成功
    advanceSuccess(id) {}
  }
}
</script>

<style lang="scss" scoped>

  .page-container {
    background: #ffffff;
    padding: 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/cargoTransferApplyEdit.vue